"use client"
import Image from "next/image";


interface LoginLayoutProps {
  children: React.ReactNode;
}

export default function LoginLayout({ children }: LoginLayoutProps) {
  return (
    <div className="h-screen flex">
      {/* Left half - Image */}
      <div className="flex justify-center items-end w-1/2 max-w-[720px] h-full relative bg-background-950">
        <div className="h-[81.5%] max-h-[835px]">
          <Image 
            width={512} 
            height={835} 
            src={'/images/login/login-banner.png'}  
            alt="login banner"
            className="h-full w-auto object-contain"
          />
        </div>
      </div>
     

      {/* Right half - Content */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-8 bg-background-0">
        <div className="w-full max-w-120">
          {children}
        </div>
      </div>
    </div>
  );
}
